import React from 'react';
import educationData from '../config/education';
import './styles/Timeline.scss';

const EducationTimeline = () => {
  return (
    <div>
      <h3 className="timeline-title">Education</h3>
      <div className="timeline">
        {educationData.map((item) => (
          <div className="timeline-item" key={item.id}>
            <div className="timeline-item-dot"></div>
            <div className="timeline-item-content">
              <h4 className="timeline-item-heading">{item.degree}</h4>
              <p className="timeline-item-subheading">{item.institution}, {item.location}</p>
              <span className="timeline-item-date">{item.startDate} &ndash; {item.endDate}</span>
              <div className="timeline-item-details">
                {item.details.map((detail, index) => (
                  <li key={index}>{detail}</li>
                ))}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default EducationTimeline;